import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RxEmitter } from 'common/rxjs/rx-emitter';
import { MessageBusEvents } from 'common/common/constants/message-bus-events';
import { WorkItemTypes } from 'common/workitems/constants/workitem-types';
import { WorkItemObservableCacheService } from 'components/work-item-lane-list/work-item-lane/work-item-widget/shared/services/work-item-observable-cache.service';
import { Subscription } from 'rxjs';
import { ActiveAssistStatus } from 'common/common/constants/active-assist-status';
import { RemoteControlService } from 'shared/services/remote-control/remote-control.service';

@Component({
  selector: 'remote-control-session-status-bubble',
  templateUrl: './remote-control-session-status-bubble.component.html',
  styleUrls: ['./remote-control-session-status-bubble.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RemoteControlSessionStatusBubbleComponent implements OnInit, OnDestroy {
  @Input()
  workItemId: string;

  @Input()
  workItemType: string;

  activeAssistStatus: ActiveAssistStatus;
  translateParams = { name: '' };

  private _workItemSubscription: Subscription;

  constructor(
    private readonly _rxEmitter: RxEmitter,
    private readonly _workItemObservableCacheService: WorkItemObservableCacheService,
    private readonly _remoteControlService: RemoteControlService,
    private readonly _changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.workItemType === WorkItemTypes.CHAT) {
      this._workItemSubscription = this._workItemObservableCacheService
        .getWorkItemObservable(this.workItemId, this.workItemType)
        .subscribe((chat) => {
          this.translateParams = { name: chat.ChatName };
          this.activeAssistStatus = chat.ActiveAssistStatus;
          this._changeDetectorRef.detectChanges();
        });
    }
  }

  async actionButtonClicked(): Promise<void> {
    if (this.activeAssistStatus === ActiveAssistStatus.Pending) {
      this._rxEmitter.send(
        `${MessageBusEvents.CancelRemoteControlSessionConfirmationVisibilityChanged}${this.workItemId}`,
        true
      );
    } else {
      await this._remoteControlService.joinRemoteControlSession(this.workItemId);
    }
  }

  get buttonText(): string {
    return this.activeAssistStatus === ActiveAssistStatus.Pending
      ? 'remoteControlSessionStatusBubble.cancel'
      : 'remoteControlSessionStatusBubble.join';
  }

  get bubbleStatus(): string {
    return this.activeAssistStatus === ActiveAssistStatus.Pending
      ? 'remoteControlSessionStatusBubble.requested'
      : 'remoteControlSessionStatusBubble.active';
  }

  get isVisible(): boolean {
    return (
      this.activeAssistStatus === ActiveAssistStatus.Pending || this.activeAssistStatus === ActiveAssistStatus.Activated
    );
  }

  get isPending(): boolean {
    return this.activeAssistStatus === ActiveAssistStatus.Pending;
  }

  ngOnDestroy(): void {
    if (this._workItemSubscription) {
      this._workItemSubscription.unsubscribe();
      this._workItemSubscription = null;
    }
  }
}
